import React from 'react';
import { bridge } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Bridge',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'bridge',
  icon: {
    baseShape: bridge,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'bridgeMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Bridge',
      itemTitleFunction: (item) => (item && item.title) || 'Bridge',
    },
    creationOptions: {
      menuText: 'Bridge',
      newTitle: 'Bridge',
      titlePlaceholder: 'Name of bridge',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          Include information such as bridge height, width, construction and any
          relevant procedures or timetables.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Lifting', isActive: false },
        { label: 'Fixed', isActive: false },
        // { label: 'Timetable', isActive: false },
        // { label: 'HAT Height', isActive: false },
        // { label: 'VHF Channel', isActive: false },
        // { label: 'Phone number', isActive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Bridge',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
